import Accounts from "./Accounts";

const routes = [...Accounts];

export default routes;
